import { titleTypography } from "../../../cm/Dashboard/FullPages/Reports/components/ReportsDetail/components/Title";
import ReportTooltip from "../../../cm/Dashboard/FullPages/Reports/components/ReportsList/components/ReportTooltip";
import HNSColors from "../../../ui library/HNSColors";
import AccordionContainer from "../../FollowUps/followup-form/modules/DynamicSection/components/AccordionContainer";
import AnalyticsChart from "../charts";
import { ACCORDION_DETAILS_SX } from "../helpers/styles";

export default function AnalyticsChartsSection({ chartsSection }) {
  if (!chartsSection || chartsSection.length === 0) {
    return null;
  }

  return (
    <>
      {chartsSection.map((section, sectionIndex) => (
        <AccordionContainer
          id={sectionIndex}
          key={section?.name ?? sectionIndex}
          title={
            <div className="flex items-center gap-2">
              <h1 className="text-left" style={titleTypography}>
                {section?.name ?? `Section ${sectionIndex + 1}`}
              </h1>
              {section?.description ? (
                <ReportTooltip description={section?.description} allowHover />
              ) : (
                <div />
              )}
            </div>
          }
          accordionDetailsSx={ACCORDION_DETAILS_SX}
        >
          <div className="flex flex-nowrap justify-evenly gap-6">
            {(section?.charts ?? []).map((chart, chartIndex, charts) => {
              const hasNextInRow = chartIndex % 3 !== 2 && chartIndex + 1 < charts.length;
              return (
                <div
                  key={chart?.data ?? chartIndex}
                  style={{
                    width: `calc(100%/${charts.length})`,
                    ...(hasNextInRow ? { borderColor: HNSColors.primary[900] } : {}),
                  }}
                  className={`min-w-0 ${hasNextInRow ? "border-r-[3px] pr-6" : ""}`}
                >
                  <AnalyticsChart chart={chart} />
                </div>
              );
            })}
          </div>
        </AccordionContainer>
      ))}
    </>
  );
}
